import { v1ApiClient } from '@/services';
import type { PathParams, RequestBody, ResponseBody } from '@/shared/api/generated';

type IssueSummaryPath = '/v1/workspaces/{workspace_id}/issues/summary';

type GetIssueSummaryParams = Partial<PathParams<IssueSummaryPath, 'post'>> &
  RequestBody<IssueSummaryPath, 'post'>;
type GetIssueSummaryResponse = ResponseBody<IssueSummaryPath, 'post'>;
type GetIssueSummaryFunction = (
  params: GetIssueSummaryParams,
) => Promise<GetIssueSummaryResponse>;

/**
 * 이슈 AI 요약 조회
 */
export const getIssueSummary: GetIssueSummaryFunction = ({
  workspace_id,
  name,
  filter_set,
}) =>
  v1ApiClient
    .post(`/workspaces/${workspace_id}/issues/summary`, {
      name,
      filter_set,
    })
    .then((res) => res.data);
